var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-container"},[_c('div',{class:['manage-content'],style:({ height: _vm.state.isMobile ? _vm.containerMobileHeight : _vm.containerHeight })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }